import { render } from "./QrCodeShareModal.vue?vue&type=template&id=7470278c"
import script from "./QrCodeShareModal.vue?vue&type=script&lang=js"
export * from "./QrCodeShareModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__